import React, { useCallback, useEffect, useState } from "react";
import permissions, { isAuthorized } from "client/utils/Permissions";
import { useDispatch, useSelector } from "react-redux";
import SecurityRoleGrid from "./SecurityRoleGrid";
import MoreOptions from "client/CommonComponents/MoreOptions";
import userManageOperation from '../../../../../../../redux/UserManagement/operations'
import { SetAddSecurityRole, setDeleteSecurityRole, setSecurityRoleById } from "redux/UserManagement/action";
import { popupInitialData } from "utils";
import SuccessBee from '../../../../../../assets/images/SuccessBee.svg';
import ConfirmationBee from '../../../../../../assets/images/ConfirmationBee.svg';
import { commonPopupDisplay } from "client/Components/Administraton/utils/AdministrationUtils";

interface IProps {
  selectedUserId?: any;
  userForm?: any;
}
const SecurityRoleGridContainer = ({
  selectedUserId,
  userForm
}: IProps) => {
  const initialRoleForm = { userId: 0, roleId: {}, providedBy: '' }
  const initialEditRoleForm = { userRoleId: 0, roleIds: 0, providedBy: '' }
  const [roleForm, setRoleForm] = useState<any>(initialRoleForm);
  const [editRoleForm, setEditRoleForm] = useState<any>(initialEditRoleForm)
  const initialRoleError = { roleNameError: '' }
  const [roleError, setRoleError] = useState<any>(initialRoleError)
  const [selectedKeys, setSelectedKeys] = React.useState<any>([]);
  const [showRolePopup, setshowRolePopup] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);
  const [rolesData, setRolesData] = useState([]);
  const [rolesEditData, setRolesEditData] = useState([]);
  const [actionType, setActionType] = useState("");
  const [selectedRoleId, setSelectedRoleId] = useState(0);
  const [selectedRoleName, setSelectedRoleName] = useState("");
  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);
  const dispatch = useDispatch();
  const dispatchAddSecurityrole = userManageOperation.dispatchAddSecurityrole(dispatch);
  const dispatchGetSecurityRoleList = userManageOperation.dispatchGetSecurityRoleList(dispatch);
  const deleteSecurityRole = userManageOperation.dispatchDeleteSecurityRole(dispatch);
  const SecurityRoleById = userManageOperation.dispatchSecurityRoleById(dispatch);
  const {
    securityRoleData,
    activeRoleData,
    addSecurityRoleVal,
    deleteSecurityUserRole,
    securityRoleById,
    addUserData,
    getUserDetails
  }: any
    = useSelector(
      (state: any) => ({
        securityRoleData: state.UserManagement.securityRoleList,
        activeRoleData: state.UserManagement.activeRolesData,
        addSecurityRoleVal: state.UserManagement.addSecurityRoleVal,
        securityRoleById: state.UserManagement.securityRoleById,
        addUserData: state.UserManagement.addUserVal,
        deleteSecurityUserRole: state.UserManagement.deleteSecurityRole,
        getUserDetails: state.UserProfile.getUserDetails
      })
    )

  const accountName = getUserDetails?.userName;

  const option = [
    {
      title: "Edit Security Role",
      value: "editSecurityRole",
      disabled: !isAuthorized(permissions.Create_Edit_Admin),
    },
    {
      title: "Delete Security Role",
      value: "deleteSecurityRole",
      disabled: !isAuthorized(permissions.Create_Edit_Admin),
    },
  ];

  const hideDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    [Popupcontent]
  );

  const handleClickPopup = () => {
    hideDialog()
    togglePopup()
    if (selectedUserId) {
      dispatchGetSecurityRoleList(selectedUserId)
    } else if (addUserData) {
      dispatchGetSecurityRoleList(addUserData)
    }
    dispatch(SetAddSecurityRole(0))
    dispatch(setSecurityRoleById({}))
  }
  const handleFailurePopup = () => {
    hideDialog()
    dispatch(SetAddSecurityRole(0))
  }
  const handleClickSave = () => {
    let valid = true;
    if (securityRoleById?.hasOwnProperty("roleId")) {
      if (editRoleForm?.roleId == null || editRoleForm?.roleId == undefined || editRoleForm?.roleId == 0) {
        valid = false;
        let error = { ...roleError };
        error.roleNameError = "Please select role name"
        setRoleError({ ...roleError, roleNameError: error.roleNameError })
      }
      else {
        setRoleError({ ...roleError, roleNameError: "" })
      }
    } else {
      if (selectedKeys == null || selectedKeys == undefined || selectedKeys.length == 0) {
        valid = false;
        let error = { ...roleError };
        error.roleNameError = "Please select role name"
        setRoleError({ ...roleError, roleNameError: error.roleNameError })
      }
      else {
        setRoleError({ ...roleError, roleNameError: "" })
      }
    }
    if (valid) {
      if (securityRoleById?.hasOwnProperty("roleId")) {
        dispatchAddSecurityrole(editRoleForm)
      } else {
        dispatchAddSecurityrole(roleForm)
      }
    }
  }
  const onEditRoleChange = (e?: any, item?: any) => {
    if (item) {
      setRoleForm({
        ...roleForm, userId: selectedUserId,
        roleIds: item?.key,
        providedBy: accountName
      });
      setRoleError({ ...roleError, roleNameError: "" });
      setEditRoleForm({
        ...editRoleForm, userRoleId: securityRoleById?.userRoleId,
        roleId: parseInt(item?.key),
        providedBy: accountName
      })
    }
  }
  const onRoleChange = (e?: any, item?: any) => {
    if (item) {
      setSelectedKeys(
        item.selected
          ? [...selectedKeys, item.key]
          : selectedKeys.filter((key: any) => key !== item.key)
      );
      setRoleError({ ...roleError, roleNameError: "" });
    }
  };
  useEffect(() => {
    let vals = selectedKeys.map(Number);
    setRoleForm({
      ...roleForm, userId: (selectedUserId || addUserData),
      roleIds: vals,
      providedBy: accountName
    })
  }, [selectedKeys])

  useEffect(() => {
    if (activeRoleData?.length > 0) {
      let roleValue = activeRoleData?.map((item: any) =>
        ({ key: item.value, text: item.text })
      );
      setRolesData(roleValue);
    }
  }, [activeRoleData])
  useEffect(() => {
    if (securityRoleById?.hasOwnProperty("roleId")) {
      setRoleForm({
        ...roleForm, userId: (selectedUserId || addUserData),
        roleIds: securityRoleById?.roleId?.toString(),
        providedBy: accountName
      })
      setEditRoleForm({
        ...editRoleForm, userRoleId: securityRoleById?.userRoleId,
        roleId: parseInt(securityRoleById?.roleId),
        providedBy: accountName
      })
    }
    if (securityRoleById?.hasOwnProperty("roleId") && activeRoleData?.length > 0) {
      const newColumns = activeRoleData?.map((item: any) =>

        ({ key: item.value, text: item.text, value: item.value })
      );
      const defaultOption = [{ key: securityRoleById?.roleId?.toString(), text: securityRoleById?.roleName?.toString(), value: securityRoleById?.roleId?.toString() }, { key: 0, text: "Select Role", value: 0 }]
      for (let i = 0; defaultOption?.length > i; i++) {
        newColumns?.unshift(defaultOption[i])
      }
      setRolesEditData(newColumns)
    }
  }, [securityRoleById, activeRoleData])

  useEffect(() => {
    if (addSecurityRoleVal != 0 ) {
      if (addSecurityRoleVal != 0 && addSecurityRoleVal != "error") {
        let message: any = []
            if((securityRoleById?.roleId != 0 && securityRoleById?.hasOwnProperty("roleId"))){
              message = "Security Roles has been updated successfully."
            }else{
              message = "Security Roles has been assigned successfully."
            }
            commonPopupDisplay(message, setPopupcontent, Popupcontent, SuccessBee, "SUCCESS", handleClickPopup)
          } else if (addSecurityRoleVal == "error") {
            let message: any  = []
            if(addSecurityRoleVal == "error"){
              message = "Error Occured while processing the request."
            } else{
              message = ""
            }
            commonPopupDisplay(message, setPopupcontent, Popupcontent, ConfirmationBee, "INFORMATION", handleFailurePopup)
          }
    }
  }, [addSecurityRoleVal])
  const togglePopup = () => {
    setshowRolePopup((prev) => !prev);
    if (showRolePopup) {
      setActionType("Add")
      setSelectedKeys([])
      setRoleError(initialRoleError)
    } else {
      dispatch(setSecurityRoleById({}))
    }
  };

  const columns = [
    {
      key: "action",
      title: "Action",
      Cell: (row: any) => {
        return (
          <>
            <MoreOptions
              onClick={optionHandler}
              options={option}
              {...row.rowData}
             data-attribute="SecurityRoleGrid_Container_Default_MoreOptions" />
          </>
        );
      },
      width: 50,
    },
    {
      key: "roleName",
      title: "Role Name",
      width: 400,
    },
    {
      key: "providedBy",
      title: "Provided By",
      width: 400,
    }
  ];
  const optionHandler = (evt: any, option: any, props: any) => {
    if (option.value === "editSecurityRole") {
      setActionType("edit");
      setshowRolePopup(true);
      SecurityRoleById(props.userRoleId)
    }
    if (option.value === "deleteSecurityRole") {
      setShowDeleteModal(true);
      setSelectedRoleId(props.userRoleId);
      setSelectedRoleName(props?.roleName)
    }
  };
  const handleDeleteModal = () => {
    setShowDeleteModal(false);
  };
  const handleDeleteClick = () => {
    deleteSecurityRole(selectedRoleId)
    setSelectedRoleId(0)
  }
  useEffect(() => {
    if (deleteSecurityUserRole) {
      setShowDeleteModal(false);
      setShowInfoModal(true)
      dispatch(setDeleteSecurityRole(false))
    }
  }, [deleteSecurityUserRole])
  const handleInfoModal = () => {
    setShowInfoModal(false);
    setSelectedRoleName("")
    dispatchGetSecurityRoleList(selectedUserId || addUserData)
  }

  return (
    <SecurityRoleGrid
      togglePopup={togglePopup}
      columns={columns}
      securityRoleData={securityRoleData}
      showRolePopup={showRolePopup}
      handleClickSave={handleClickSave}
      setSelectedKeys={setSelectedKeys}
      selectedKeys={selectedKeys}
      roleError={roleError}
      setRoleError={setRoleError}
      showDeleteModal={showDeleteModal}
      handleDeleteModal={handleDeleteModal}
      onRoleChange={onRoleChange}
      rolesData={rolesData}
      addSecurityRoleVal={addSecurityRoleVal}
      handleFailurePopup={handleFailurePopup}
      handleClickPopup={handleClickPopup}
      selectedUserId={selectedUserId}
      securityRoleById={securityRoleById}
      actionType={actionType}
      rolesEditData={rolesEditData}
      handleDeleteClick={handleDeleteClick}
      showInfoModal={showInfoModal}
      handleInfoModal={handleInfoModal}
      selectedRoleName={selectedRoleName}
      roleForm={roleForm}
      onEditRoleChange={onEditRoleChange}
      userForm={userForm}
      addUserData={addUserData}
      Popupcontent = {Popupcontent}
    />
  )
}

export default SecurityRoleGridContainer;